<template>
  <IAMEntityInfoTab :model="model" :show-name="true" :show-active="true" :show-coc-number="true" :show-type="true" />
</template>

<script setup lang="ts">
import { Organisation } from '@infuse/api/iam/organisation';
import { IAMEntityInfoTab } from '@infuse/iam/components';

const props = defineProps<{
  model: Organisation;
}>();
</script>
